module.exports = __webpack_public_path__ + "img/ch16_09_地下工厂.c4e07ec6.jpg";